// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 21:02:54

export default {
  "id": "fight-for-the-tree",
  "slug": "fight-for-the-tree",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/fd590b333360447eb367a9abfa7424b0-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/fd590b333360447eb367a9abfa7424b0/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Fight for the Tree",
      "description": "The gaming world is facing a serious tree crisis. Evil forces are running wild, and the trees are in great danger.\nAs a player, your mission is to protect these precious trees. Even when you're offline, your character will keep fighting to safeguard the trees, constantly accumulating experience and resources.\nIn the game, there's also a group of cute little sapling creatures imprisoned by the evil forces. You need to rescue them one by one through battles, explorations, and so on. ",
      "instructions": "In the mysterious game world, Evil forces are raging everywhere.  As a player, you bear the sacred mission of guarding trees.During the battle, the character will automatically attack the enemy, continuously accumulating experience points and various resources. There are multiple maps with different styles in the game, ranging from tranquil forests to mysterious valleys.  ",
      "genres": [
        "Battle",
        "Simulation"
      ],
      "tags": [
        "1player",
        "fighting",
        "rpg",
        "skill"
      ]
    },
    "zh-CN": {
      "title": "保卫大树",
      "description": "游戏世界正面临严重的树木危机。邪恶势力横行，树木处于极大危险之中。\n作为玩家，你的任务是保护这些珍贵的树木。即使你离线，你的角色也会持续战斗，保护树木，不断积累经验和资源。\n在游戏中，还有一群被邪恶势力囚禁的可爱的小树苗生物。你需要通过战斗、探险等方式逐一解救它们。",
      "instructions": "在神秘的游戏世界中，邪恶势力无处不在。作为玩家，你肩负着守护树木的神圣使命。在战斗中，角色将自动攻击敌人，持续积累经验点和各种资源。游戏中有多个不同风格的地图，从宁静的森林到神秘的峡谷。",
      "genres": [
        "战斗",
        "模拟"
      ],
      "tags": [
        "1玩家",
        "战斗",
        "角色扮演游戏",
        "技能"
      ]
    },
    "zh-TW": {
      "title": "為樹而戰",
      "description": "遊戲世界面臨著嚴重的樹木危機。邪惡力量橫行無忌，樹木處於巨大的危險之中。\n作為玩家，你的使命是保護這些珍貴的樹木。即使你在離線狀態，你的角色也會持續奮戰以保護樹木，不斷累積經驗和資源。\n在遊戲中，還有一群可愛的小樹苗生物被邪惡力量囚禁。你需要通過戰鬥、探索等方式逐個解救他們。",
      "instructions": "在神秘的遊戲世界裡，邪惡力量四處肆虐。作為一名玩家，你負有守護樹木的神聖使命。在戰鬥中，角色將自動攻擊敵人，不斷累積經驗值和各種資源。遊戲中有多張風格各異的地圖，從寧靜的森林到神秘的溝谷。",
      "genres": [
        "戰鬥",
        "模擬"
      ],
      "tags": [
        "1玩家",
        "戰鬥",
        "角色扮演遊戲",
        "技能"
      ]
    },
    "zh-HK": {
      "title": "奮戰為樹",
      "description": "遊戲界面臨著嚴重的樹木危機。惡勢力橫行無忌，樹木正處於巨大的威脅之中。\n作為玩家，你的使命是保護這些寶貴的樹木。即使你在離線狀態，你的角色也會不斷奮戰，以保護樹木，並不斷累積經驗和資源。\n在遊戲中，還有一群可愛的小樹苗生物被惡勢力囚禁。你需要一個個透過戰鬥、探索等方式將他們解救出來。",
      "instructions": "在神秘的游戏世界中，邪惡力量充滿各處。作為玩家，你負有守護樹木的神聖使命。在戰鬥中，角色會自動攻擊敵人，不斷累積經驗點和各種資源。遊戲中有多種風格不同的地圖，從寧靜的森林到神秘的溝谷。",
      "genres": [
        "戰鬥",
        "模擬"
      ],
      "tags": [
        "1玩家",
        "作戰",
        "遊戲角色扮演",
        "技能"
      ]
    },
    "ja": {
      "title": "木のための戦い",
      "description": "ゲームの世界は深刻な木の森の危機に直面しています。邪悪な力が荒れ放題で、木々は大きな危険にさらされています。\nプレイヤーとしてあなたの任務は、これらの貴重な木々を守ることです。オフラインでも、あなたのキャラクターは木々を守るために戦い続け、常に経験値と資源を積み重ねます。\nゲームには、邪悪な力に捕らえられた可愛い小さな芽の生き物たちのグループもいます。あなたは彼らをそれぞれ戦闘、探検などを通じて救出する必要があります。",
      "instructions": "神秘的ゲームワールドで、悪の力が至る所で燃え上がっている。プレイヤーとして、あなたは樹木を守る神聖な使命を持っている。戦闘中、キャラクターは自動的に敵を攻撃し、経験値やさまざまな資源を連続して積み重ねる。ゲームには、静かな森から神秘的な谷に至るまで、様々なスタイルの複数のマップが用意されている。",
      "genres": [
        "戦闘",
        "シミュレーション"
      ],
      "tags": [
        "1プレイヤー",
        "戦闘",
        "RPG",
        "スキル"
      ]
    },
    "ko": {
      "title": "나무를 지키기 위해 싸우다",
      "description": "게임 세계는 심각한 나무 위기에 직면하고 있습니다. 악한 힘들이 난무하고 있으며 나무들이 큰 위험에 처해 있습니다.\n플레이어로서 당신의 임무는 이 귀중한 나무들을 보호하는 것입니다. 온라인이 아닌 상태에서도 당신의 캐릭터는 나무들을 지키기 위해 싸우고 있으며, 지속적으로 경험치와 자원을 모으습니다.\n게임에서는 악한 힘들에 의해 억류된 귀여운 작은 나무 씨앗 생물들이 있습니다. 이들을 하나씩 전투, 탐험을 통해 구출해야 합니다.",
      "instructions": "미스터리한 게임 세계에서 악의 힘은 어디서나 불타고 있습니다. 플레이어로서 당신은 성圣地의 임무를 맡고 있으며, 전투 중에는 캐릭터가 자동으로 적을 공격하며 경험치와 다양한 자원을 지속적으로 모읍니다. 평화로운 숲에서부터 미스터리한 계곡까지 다양한 스타일의 여러 맵이 있습니다.",
      "genres": [
        "전투",
        "시뮬레이션"
      ],
      "tags": [
        "1플레이어",
        "전투",
        "RPG",
        "스킬"
      ]
    },
    "fr": {
      "title": "Combattre pour l'Arbre",
      "description": "Le monde du jeu vidéo est confronté à une grave crise forestière. Les forces du mal se déchaînent, et les arbres sont en grand danger.\nEn tant que joueur, votre mission est de protéger ces précieuses forêts. Même lorsque vous êtes déconnecté, votre personnage continuera de combattre pour protéger les arbres, accumulant constamment de l'expérience et des ressources.\nDans le jeu, il y a également un groupe de petites créatures de semis capturées par les forces du mal. Vous devez les libérer une par une à travers des batailles, des explorations et ainsi de suite.",
      "instructions": "Dans le monde de jeu mystérieux, les forces du mal grondent partout. En tant que joueur, vous portez la mission sacrée de protéger les arbres. Pendant la bataille, le personnage attaquera automatiquement l'ennemi, accumulant ainsi constamment des points d'expérience et divers ressources. Le jeu propose plusieurs cartes aux styles différents, allant des forêts apaisantes aux vallées mystérieuses.",
      "genres": [
        "Bataille",
        "Simulation"
      ],
      "tags": [
        "1 joueur",
        "combat",
        "RPG",
        "compétence"
      ]
    }
  }
};
